import { CartAddEvent } from '@theme/events';

// One-tap "Add" on the cart add-on row. Adds 1 of the variant, then fires Horizon's own
// cart-update event so the drawer / cart page re-render (bar, items, totals, bubble).
if (!window.__hikmaCartOffer) {
  window.__hikmaCartOffer = true;

  document.addEventListener('click', async (event) => {
    const button = event.target instanceof Element ? event.target.closest('[data-hikma-add]') : null;
    if (!button) return;
    event.preventDefault();

    const variantId = button.getAttribute('data-hikma-add');
    button.setAttribute('aria-busy', 'true');

    try {
      const root = window.Shopify?.routes?.root || '/';
      const addResponse = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] }),
      });
      if (!addResponse.ok) throw new Error(`add failed ${addResponse.status}`);
      const cart = await (await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } })).json();

      document.dispatchEvent(
        new CartAddEvent(cart, 'hikma-cart-offer', {
          source: 'hikma-cart-offer',
          itemCount: cart.item_count,
          variantId: String(variantId),
        })
      );
    } catch (error) {
      console.error('[hikma-cart-offer]', error);
      button.removeAttribute('aria-busy');
    }
  });
}
